<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../../assets/images/banner_list.jpg" />
            <div class="btext">
                <h3>通知公告</h3>
                <p>最新金融快讯，全球投资信息，行业特色综合类新闻资讯</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资讯中心</el-breadcrumb-item>
                <el-breadcrumb-item>通知公告</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="1"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/notificationAnnouncement' }">
                            <el-menu-item index="1"><span slot="title" >通知公告</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/centerNews' }">
                            <el-menu-item index="2"><span slot="title">平台新闻</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/industryInformation' }">
                            <el-menu-item index="3"><span slot="title">行业资讯</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/investmentExpress' }">
                            <el-menu-item index="4"><span slot="title" >投资快讯</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/communicationCooperation' }">
                            <el-menu-item index="5"><span slot="title">交流合作</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/caseShow' }">
                            <el-menu-item index="6"><span slot="title">案例展示</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <ul class="list_news" >
                            <li v-for="item in NotificationAnnouncementArray"><span>{{item.publishTime|date_from_unix_YearMonthDay}}</span><a v-on:click="toNotificationAnnouncementDetail(item)">{{item.title}}</a></li>
                        </ul>
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqNotificationAnnouncementList} from "../../../../api/contentManagement-api";

    export  default {
        data(){
            return{
                total:0,
                pageNum:1,
                pageSize:10,
                NotificationAnnouncementArray:[],
            }
        },
        methods:{
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getNotificationAnnouncement();
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getNotificationAnnouncement();
            },
            getNotificationAnnouncement(){
                reqNotificationAnnouncementList({pageNum: this.pageNum, pageSize: this.pageSize}).then((res)=>{
                    if(res.data.code===1){
                        this.total=res.data.data.total;
                        this.NotificationAnnouncementArray=res.data.data.list;
                    }else {
                        this.NotificationAnnouncementArray=[{title:'抱歉，暂无数据'}];
                    }
                })
            },
            toNotificationAnnouncementDetail(item){
                this.$router.push({path:'/notificationAnnouncementDetail',query:{id:item.id,total:this.total}});
            },

        },
        mounted(){
            this.getNotificationAnnouncement();
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/contentManagement/referenceCenter/notificationAnnouncement/NotificationAnnouncement.vue